/**
 * @description 判断当前浏览器是否支持webp格式的图片
 * @returns
 */
export const _isSupportWebp = (): boolean => {
  // const ua = navigator.userAgent.toLowerCase();
  // const iosWd = 'iphone os ';
  // if (ua.indexOf(iosWd) > -1) {
  //   const ver = parseInt(ua.split(iosWd)[1].split('_')[0]);
  //   if (ver < 14) {
  //     return false;
  //   }
  // } else {
  //   const macWd = 'mac os ';
  //   if (ua.indexOf(macWd) > -1) {
  //     // 如果是苹果 mac 系统，需要进一步区分 safari 和 chrome
  //     if (ua.indexOf('safari') > -1 && ua.indexOf('chrome') == -1) {
  //       return false;
  //     }
  //   }
  // }
  // return true;
  const canvas =
    typeof document === 'object'
      ? document.createElement('canvas')
      : { width: null, height: null, toDataURL: null };
  canvas.width = canvas.height = 1;
  return canvas.toDataURL ? canvas.toDataURL('image/webp').indexOf('image/webp') === 5 : false;
};
